import { Decimal } from 'decimal.js';

interface ReorderSourceItem {
  product_variation?: number | null;
  name: string;
  quantity?: string;
  unit_price: string | null;
}

export interface ReorderPlan {
  /** 商品バリエーションID → コピーする数量 */
  quantities: Map<number, number>;
  /** 商品バリエーションID → 元の注文での単価 */
  previousUnitPrices: Map<number, string>;
  /** 現在のカタログに無いためコピーできなかった商品名 */
  unavailableNames: string[];
}

/**
 * 過去の注文の明細から、新規発注フォームへコピーする数量を組み立てる。
 * 数量0の明細は対象外。商品マスタとの紐付けが切れた明細や、現在のカタログに無い商品はコピーせず名前を返す。
 */
export const buildReorderPlan = (
  sourceItems: readonly ReorderSourceItem[],
  catalogVariationIds: ReadonlySet<number>,
): ReorderPlan => {
  const quantities = new Map<number, number>();
  const previousUnitPrices = new Map<number, string>();
  const unavailableNames: string[] = [];

  for (const item of sourceItems) {
    const quantity = new Decimal(item.quantity ?? '0');
    if (quantity.lessThanOrEqualTo(0)) continue;

    const variationId = item.product_variation;
    if (variationId == null || !catalogVariationIds.has(variationId)) {
      unavailableNames.push(item.name);
      continue;
    }
    quantities.set(variationId, quantity.plus(quantities.get(variationId) ?? 0).toNumber());
    if (item.unit_price !== null) previousUnitPrices.set(variationId, item.unit_price);
  }

  return { quantities, previousUnitPrices, unavailableNames };
};
